import React from "react";
import { Container, Row, Col, Input } from "reactstrap";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {
  Typography,
  IconButton,
  Avatar,
  ListItemAvatar,
  ListItemText,
  AppBar,
  ListItem,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import List from "@material-ui/core/List";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import { formatTime } from "../../helpers/time.helper";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import BlockIcon from "@material-ui/icons/Block";
import EventLabel2 from "../../components/EventLabel2/EventLabel2";

export function ChatBox({
  message = "",
  id,
  timeStamp,
  name,
  size,
  onLike,
  likes = 0,
  clientKey = null,
  fromYou = false,
  last = false,
  first = false,
  lang = null,
  style,
}) {
  return (
    <div style={{ width: "100%" }}>
      {/*    {first ?  */}
      <Row style={{ width: "100%", margin: 0 }}>
        <Col
          className={
            fromYou ? "messages messages--sent" : "messages messages--received"
          }
        >
          <div
            style={{ color: style.color }}
            className={"time-stamp" + (size == 2 ? " xl" : "")}
          >
            <strong>
              {fromYou ? (
                /*  ? (first ?  */ <SystemLabel
                  name="Me"
                  languageCode={lang}
                /> /* : '')  */
              ) : !name  ? (
                <React.Fragment>
                  <SystemLabel name="AnonymousClient" languageCode={lang} />
                  {clientKey ? clientKey.substring(0, 8) : ""}
                </React.Fragment>
              ) : (
                name
              )}
            </strong>{" "}
            <div
              style={{ color: style.color, opacity: 0.8 }}
              className={"time-stamp" + (size == 2 ? " xl" : "")}
            >
              {timeStamp ? (
                <AccessTimeIcon style={{ fontSize: 12, margin: "0px 3px" }} />
              ) : (
                ""
              )}
              {timeStamp ? formatTime(timeStamp, lang) : ""}
            </div>
          </div>
        </Col>
      </Row>{" "}
      {/* : null
            } */}
      <Row
        style={{ width: "100%", margin: 0 }}
        className={
          fromYou ? "messages--sent--wrapper " : "messages--received--wrapper"
        }
      >
        <Col
          style={{
            display: "flex",
            justifyContent: fromYou ? "flex-end" : "flex-start",
          }}
          className={
            fromYou
              ? message.toString().includes("*!")
                ? "messages messages--sent yell"
                : "messages messages--sent"
              : message.toString().includes("*!")
              ? "messages messages--received yell"
              : "messages messages--received"
          }
        >
          {message.toString() == "THUMB_UP" ? (
            <div
              style={{
                position: "relative",
                backgroundColor: "transparent",
              }}
              className={"thumb" + (size == 2 ? " xl" : "")}
            >
              <ThumbUpIcon
                style={{
                  color: fromYou
                    ? style.sender.thumbColor
                    : style.receiver.thumbColor,
                }}
              />
            </div>
          ) : (
            <div
              style={{
                fontFamily: style.fontFamily,
                lineHeight: "normal",
                fontSize: style.fontSize,
                color: fromYou ? style.sender.color : style.receiver.color,
                background: fromYou
                  ? style.sender.backgroundColor
                  : style.receiver.backgroundColor,
              }}
              className={"message" + (size == 2 ? " xl" : "")}
            >
              {parseMessage(message, fromYou)}

              <div
                onClick={() =>
                  message.toString() != "THUMB_UP" ? onLike(id) : null
                }
                className={
                  "liked-message-box" + (likes < 1 ? " empty-like" : "")
                }
              >
                <ThumbUpIcon  />{" "}
                {likes > 0 ? likes : ""}
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}

const parseMessage = (message, fromYou) => {
  if (message.includes("JX_ADMIN_REMOVED:"))
    return null/* (
      <div style={{ display: "inline-flex" }}>
        <BlockIcon
          style={{ color: fromYou ? "#fff" : "#333", marginRight: 10 }}
        />
        <em style={{ paddingTop: 2 }}>
          <EventLabel2
            name="ThisMessagesIsBlocked"
            groupName="DigitalMeeting.Chat"
          />{" "}
        </em>
      </div>
    ); */
  if (message.includes("https://"))
    return (
      <ChatLink fromYou={fromYou} text={message.toString().replace("*!", "")} />
    );
  else return message.toString().replace("*!", "");
};

const ChatLink = ({ text, linkStyle, fromYou = false }) => {
  const [failed, setFailed] = React.useState(false);
  const urlify = () => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    let url = "";
    text.replace(urlRegex, function (u) {
      url = u;
    });
    return url;
  };

  const textify = () => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    let style = fromYou
      ? "text-decoration: underline; color: #fff;cursor: pointer;"
      : "text-decoration: underline; color: #2a40fe;cursor: pointer;";
    return text.replace(urlRegex, function (url) {
      return `<a href="${url}" style="${style}" target="_blank" >${url} </a>`;
    });
  };
  /*     const url = urlify(); */
  const content = textify();
  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: content }} />


    </div>
  );
};
